import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useService } from '../../services/services';
import Title from '../../components/common/title';
import Table from '../../components/common/table/table';
import css from './index.module.css';
import Token from '../../interfaces/token';
import { route } from '../../services/utils';
import { TOKENS_CREATE, TOKENS_VIEW } from '../../router/routes';
import useDefaultTableTopbar from '../../components/common/table/default-topbar';

export default function ApiTokens() {
  const { t } = useTranslation();
  const { tokenService } = useService();

  const [TopbarComponent] = useDefaultTableTopbar(route(TOKENS_CREATE));

  const request = useCallback(
    (page: number, sort: string, desc: boolean, filter: any) => {
      return tokenService.index({ page, sort, desc, ...filter });
    },
    [tokenService]
  );

  return (
    <>
      <Title title={t('pages.tokens.title')} />
      <div className={css['body']}>
        {TopbarComponent}

        <Table<Token>
          request={request}
          keyAccessor="id"
          columns={[
            {
              accessor: 'name',
              header: t('pages.tokens.name'),
              sortable: true,
              className: css['strong'],
            },
            {
              accessor: 'last_used_at',
              header: t('pages.tokens.last_used_at'),
              sortable: true,
            },
            {
              accessor: 'updated_at',
              header: t('pages.tokens.updated_at'),
              sortable: true,
            },
            {
              accessor: 'created_at',
              header: t('pages.tokens.created_at'),
              sortable: true,
            },
          ]}
          viewRoute={route(TOKENS_VIEW, {})}
          viewRecordAbility={{ title: 'public' }}
        />
      </div>
    </>
  );
}
